import React from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import D3Logo from '../../assets/DCH-Logo.svg'

class MainNavBar extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { scrollPos: 0, hide: false }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const { scrollPos } = this.state
    const currentScrollPos = window.pageYOffset
    const scrollPosDiff = scrollPos - currentScrollPos
    if (scrollPos > currentScrollPos) {
      if (scrollPosDiff > 5) {
        this.setState({ hide: false })
      }
    }
    if (currentScrollPos > 80) {
      this.setState({ hide: true })
    }
    this.setState({ scrollPos: currentScrollPos })
  }

  render() {
    const { navProps, strings } = this.props
    const { hide } = this.state
    const display = navProps ? navProps.display : false
    return display ? (
      <div className={`navbar${hide ? ' hide' : ''}`}>
        <div className='main'>
          <Link to='/' className='logo-link'>
            <img className='d3-logo' src={D3Logo} alt='d3-logo' />
          </Link>
          <div>
            <b>{strings.create_account_title_self}</b>
          </div>
        </div>
      </div>
    ) : null
  }
}

MainNavBar.propTypes = {
  dropdownText: PropTypes.string,
  navProps: PropTypes.object,
  strings: PropTypes.object,
  onLogout: PropTypes.func,
  selectedUser: PropTypes.string,
  showNavLinks: PropTypes.bool,
  studies: PropTypes.array,
  study: PropTypes.object,
  subroute: PropTypes.string,
  user: PropTypes.object,
}

export default MainNavBar



// WEBPACK FOOTER //
// ./src/layouts/NavBar/MainNavBar.js